import { BoxProps, colors, Heading, Text } from "@biblioteksentralen/react";
import { getPath } from "@libry-content/common";
import { ResolvedServiceSummary } from "@libry-content/common/src/services/groq/resolveService";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { useSitePalette } from "../../utils/useSitePalette";
import { CommonServicePreview } from "../digitalLibrary/ServicePreview";
import InternalLink from "../InternalLink";

interface Props {
  service: ResolvedServiceSummary;
  headingSize?: "h2" | "h3";
  isFullsize?: boolean;
}

export function ServicePreview({ service, headingSize, isFullsize }: Props) {
  const { ts } = useTranslation();

  return (
    <CommonServicePreview
      image={service.image}
      heading={ts(service.title)}
      teaser={ts(service.teaser)}
      href={getPath(service)}
      doc={service}
      headingSize={headingSize}
      aboveHeading={<Badge background={colors.white}>{ts(service.serviceType?.label)}</Badge>}
      height="100%"
      isFullsize={isFullsize}
    />
  );
}

const Badge = (props: { children: React.ReactNode } & BoxProps) => (
  <Text textTransform="uppercase" fontSize="2xs" padding="0 0.5em" borderRadius="sm" {...props} />
);

export const BasicServicePreview = (props: Props) => {
  const { ts } = useTranslation();
  const paletteColor = useSitePalette().colors.card;

  return (
    <Heading as={props.headingSize} size="sm" padding=".5em 1em" {...paletteColor.css} borderRadius="1rem">
      <InternalLink variant="plain" href={getPath(props.service)}>
        {ts(props.service.title)}
      </InternalLink>
    </Heading>
  );
};
